import { Text, TextProps } from 'wix-ui-tpa/cssVars';
import React from 'react';
import { classes, st } from './Text.st.css';
import { useEnvironment } from '@wix/yoshi-flow-editor';

export enum TextType {
  Title = 'title',
  Subtitle = 'subtitle',
  Primary = 'primary',
  Secondary = 'secondary',
}

type TextComponentProps = {
  type?: TextType;
} & TextProps;

const TextComponent: React.FC<TextComponentProps> = (props) => {
  const {
    type,
    tagName,
    className,
    children,
    'data-hook': dataHook,
    ...rest
  } = props;
  const { isMobile, isRTL } = useEnvironment();

  return (
    <Text
      className={st(
        classes.root,
        {
          isMobile,
          isRTL,
          ...(type ? { type } : {}),
        },
        className,
      )}
      data-hook={dataHook}
      tagName={tagName}
      {...rest}
    >
      {children}
    </Text>
  );
};

export default TextComponent;
